import request from '../utils/request';

// 获取我的收藏 展商列表
export function getExLists(data) {
  let formData = new FormData();
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });
  return request({
    url: '/frontAudience/myCollection/exhibitor',
    method: 'POST',
    data: formData,
  });
}

// 删除收藏
export function delCollect(data) {
  return request({
    url: '/frontAudience/myCollection/unfavorite',
    method: 'get',
    params: data,
  });
}
// 展品列表
export function getColProductsLists(data) {
  return request({
    url: '/frontAudience/myCollection/exhibits',
    method: 'POST',
    params: data,
  });
}

// 我的直播列表
export function getColLiveLists() {
  return request({
    url: '/frontAudience/myCollection/live',
    method: 'POST',
  });
}

// 我的活动列表

export function getColActivityLists() {
  return request({
    url: '/frontAudience/myCollection/activity',
    method: 'POST',
  });
}
